import { useTranslation } from 'react-i18next';

import { Divider } from 'storybook';
import { getPalletLabel } from 'utils/functions';
import { currencyFormatter } from 'utils/numberFormatter';

import styles from './PalletsSummaryWithTotalPriceAndAmount.module.css';

type PalletsSummaryWithTotalPriceAndAmountProps = {
   palletsTotalPrice: number;
   palletsSum: number;
   isOrderFree: boolean;
};

const PalletsSummaryWithTotalPriceAndAmount = ({
   palletsTotalPrice,
   palletsSum,
   isOrderFree,
}: PalletsSummaryWithTotalPriceAndAmountProps) => {
   const { t } = useTranslation();

   return (
      <div className={styles.palletsSummary}>
         <h3>{t('charges.total')}</h3>
         <span>
            <span>{`${palletsSum} ${getPalletLabel(palletsSum)}`}</span>
            <Divider variant="vertical" className={styles.palletsSummaryDivider} />
            <span>
               {isOrderFree
                  ? t('palletsSummaryWithTotalPriceAndAmount.free')
                  : `${currencyFormatter.format(palletsTotalPrice)} PLN`}
            </span>
         </span>
      </div>
   );
};

export default PalletsSummaryWithTotalPriceAndAmount;
